import React from "react"

import * as s from "./Spacing.module.scss"

export const Spacing = ({ data }) => {
  const visibilityClass = visibility => {
    switch (visibility) {
      case "mobile_only":
        return s.spacing__mobileOnly
        break
      case "desktop_only":
        return s.spacing__desktopOnly
        break
      case "all":
        return s.spacing
        break
      default:
        s.spacing
        break
    }
  }

  const spacingClass = spacing => {
    switch (spacing) {
      case "180px":
        return s.spacing__180px
        break
      case "140px":
        return s.spacing__140px
        break
      case "100px":
        return s.spacing__100px
        break
      case "72px":
        return s.spacing__72px
        break
      case "40px":
        return s.spacing__40px
        break
      case "20px":
        return s.spacing__20px
        break
      default:
        s.spacing
        break
    }
  }
  if (!data.spacing) {
    return <></>
  }

  return (
    <>
      {data.spacing.map((breakpoint, idx) => {
        return (
          <div
            key={idx}
            className={`${visibilityClass(
              breakpoint.visibility,
            )} ${spacingClass(breakpoint.spacing)}`}
          />
        )
      })}
    </>
  )
}
